import TAB_TYPE from '@/router/home/components/common/nav-tab/config'
export default {
  data() {
    return {
      tabHeight: 0,
      scrollIndex: TAB_TYPE.TAB_DETAIL,
      paddingBottom: 0,
      bottomHeight: 0
    }
  },

  mounted() {
    // const scroll =
    // document.body.scrollHeight - document.body.clientHeight;
    // const location = this.$refs.noticeId.$el.offsetTop || this.$refs.noticeId.offsetTop;
    // this.bottomHeight = location - scroll;
    // this.$refs.bottom.style.height = this.bottomHeight + "px";
  },
  // watch: {
  //   commentCount(val) {
  //     if (val > 0) {
  //       console.log('commentCount');
  //       this.setPaddingBottom('commentId')
  //     }
  //   },
  //   otherServiceDatas(val) {
  //     if (val.length > 0) {
  //       console.log('otherServiceDatas');
  //       this.setPaddingBottom('productId')
  //     }
  //   }
  // },
  methods: {
    handleScroll({ scrollTop, tabs }) {
      // if (this.tabHeight === 0) {
      //   this.tabHeight = this.$refs.navTab.$el.getBoundingClientRect().height;
      // }
      // let tabOffsets = [];
      // tabs.forEach(element => {
      //   let scroll = 0;
      //   if (this.$refs[element.id].$el) {
      //     scroll = this.$refs[element.id].$el.offsetTop;
      //   } else {
      //     scroll = this.$refs[element.id].offsetTop;
      //   }
      //   tabOffsets.push(scroll);
      // });
      // for (let index = 0; index < tabOffsets.length; index++) {
      //   const element = tabOffsets[index] - this.tabHeight;
      //   if (scrollTop <= element) {
      //     const i = Math.max(index - 1, 0);
      //     if (tabs[i]) {
      //       this.scrollIndex = tabs[i].id;
      //       break;
      //     }
      //   } else {
      //     if (index === tabOffsets.length - 1) {
      //       this.scrollIndex = tabs[tabs.length - 1].id;
      //       break;
      //     }
      //   }
      // }
    },
    changeTab(type) {
      // if (this.tabHeight === 0) {
      //   this.tabHeight = this.$refs.navTab.$el.getBoundingClientRect().height;
      // }
      // let scroll = 0;
      // if (this.$refs[type.id].$el) {
      //   scroll = this.$refs[type.id].$el.offsetTop;
      // } else {
      //   scroll = this.$refs[type.id].offsetTop;
      // }
      // console.log(document.body.scrollHeight - document.body.clientHeight);
      // console.log(scroll);
      // window.scrollTo(0, scroll - this.tabHeight + 5);
    },
    setPaddingBottom(id) {
      // setTimeout(() => {
      //   const scroll =
      //     document.body.scrollHeight - document.body.clientHeight;
      //   const location = this.$refs[id].$el.offsetTop || this.$refs[id].offsetTop;
      //   const paddingBottom = location - scroll + this.bottomHeight;
      //   console.log(id);
      //   console.log(paddingBottom);
      //   if (paddingBottom > this.paddingBottom) {
      //     this.paddingBottom = paddingBottom;
      //     this.$refs.bottom.style.height = paddingBottom + "px";
      //     console.log(this.$refs.bottom);
      //   }
      // }, 200);
    }
  }
}
